import type { TourStep } from '@/components/ui/Tour';
import { PROFESSIONAL_UPGRADE_TOUR_STEP_IDS } from './tour-constants';

function StepContent({ title, description }: { title: string; description: string }) {
  return (
    <div>
      <h3 className="mb-1 font-semibold text-foreground">{title}</h3>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
}

export function getProfessionalUpgradeTourSteps(opts: {
  hasMatchPlay: boolean;
}): TourStep[] {
  const steps: TourStep[] = [
    {
      content: (
        <StepContent
          title="Online payments"
          description="Connect Stripe to accept card payments at checkout. Families can book and pay instantly on your public academy page."
        />
      ),
      selectorId: PROFESSIONAL_UPGRADE_TOUR_STEP_IDS.PAYMENTS,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Development programs"
          description="Create skill pathways, track progress, and run invitation-only programs for advanced players."
        />
      ),
      selectorId: PROFESSIONAL_UPGRADE_TOUR_STEP_IDS.PROGRAMS,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Bookings and waitlists"
          description="Review online enrollments, manage waitlists when lessons fill up, and process refund requests from one place."
        />
      ),
      selectorId: PROFESSIONAL_UPGRADE_TOUR_STEP_IDS.BOOKINGS,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Professional lesson settings"
          description="Turn on waitlists, make-up credits, SMS reminders, and low-enrollment alerts from Academy settings."
        />
      ),
      selectorId: PROFESSIONAL_UPGRADE_TOUR_STEP_IDS.ACADEMY_SETTINGS,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Member portals and admins"
          description="Students, guardians, and coaches can now sign in to book and manage lessons. Use this toggle to open the coach dashboard. Invite up to two academy administrators from Settings → Administrators."
        />
      ),
      selectorId: PROFESSIONAL_UPGRADE_TOUR_STEP_IDS.DASHBOARD_MODE_SWITCH,
      position: 'bottom',
    },
  ];

  if (opts.hasMatchPlay) {
    steps.push({
      content: (
        <StepContent
          title="Play events"
          description="Run social play, round robins, and tournaments with online registration and court holds."
        />
      ),
      selectorId: PROFESSIONAL_UPGRADE_TOUR_STEP_IDS.PLAY_EVENTS,
      position: 'right',
    });
  }

  return steps;
}
